import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import Link from "@Components/atoms/Link";
import { ReactComponent as IconBox } from "@Icons/box.svg";
import { ReactComponent as IconHeart } from "@Icons/heart.svg";
import { ReactComponent as IconLock } from "@Icons/lock.svg";
import { ReactComponent as IconTruck } from "@Icons/truck.svg";
import mastercardLogo from "@Images/mastercard.png";
import paypalLogo from "@Images/paypal.png";
import visaLogo from "@Images/visa.png";
import { Currency } from "@Types/api/price";
import { Image } from "@Types/images";
import { deliveryCompagnies } from "@Utils/delivery";
import { faqLinks } from "@Utils/links";
import "./style.scss";

interface Props {
  currency?: Currency;
  hasPackagingInfo?: boolean;
}

const FooterInfos: FunctionComponent<Props> = ({ currency = "EUR", hasPackagingInfo = false }) => {
  const intl = useIntl();
  const freeDeliveryAmount = intl.formatNumber(50, {
    currency,
    minimumFractionDigits: 0,
    style: "currency",
  });
  const paymentTypes = [
    { name: "Mastercard", src: mastercardLogo },
    { name: "Visa", src: visaLogo },
    { name: "Paypal", src: paypalLogo },
  ];

  return (
    <div className="FooterInfos">
      <div className="FooterInfos-item">
        <div className="FooterInfos-item-infos">
          <p className="FooterInfos-item-title">
            <IconLock />
            <span>{intl.formatMessage({ id: "cheerz_Footer_infos_payment_title" })}</span>
          </p>
          {paymentTypes.map(({ name, src }: Image) => (
            <img alt={name} className="FooterInfos-item-logo" key={name} src={src} />
          ))}
        </div>
        <Link href={`${faqLinks.payment[intl.locale]}`} targetBlank={true}>
          {intl.formatMessage({ id: "cheerz_CartCheckoutTotal_more_infos" })}
        </Link>
      </div>

      <div className="FooterInfos-item">
        <p className="FooterInfos-item-title">
          {hasPackagingInfo ? (
            <>
              <IconBox />
              <span>{intl.formatMessage({ id: "cheerz_Footer_infos_packaging_title" })}</span>
            </>
          ) : (
            <>
              <IconHeart />
              <span>{intl.formatMessage({ id: "cheerz_Footer_infos_free_delivery_title" })}</span>
            </>
          )}
        </p>
        <p className="FooterInfos-item-text">
          {hasPackagingInfo
            ? intl.formatMessage({ id: "cheerz_Footer_infos_packaging_description" })
            : intl.formatMessage(
                { id: "cheerz_Footer_infos_free_delivery_description" },
                { value: freeDeliveryAmount }
              )}
        </p>
      </div>

      <div className="FooterInfos-item">
        <div className="FooterInfos-item-infos">
          <p className="FooterInfos-item-title">
            <IconTruck />
            <span>{intl.formatMessage({ id: "cheerz_Footer_infos_delivery_title" })}</span>
          </p>
          {deliveryCompagnies[intl.locale].map(({ name, src }: Image) => (
            <img alt={name} className="FooterInfos-item-logo" key={name} src={src} />
          ))}
        </div>
        <Link href={`${faqLinks.delivery[intl.locale]}`} targetBlank={true}>
          {intl.formatMessage({ id: "cheerz_CartCheckoutTotal_more_infos" })}
        </Link>
      </div>
    </div>
  );
};

export default FooterInfos;
